// One toast at a time, floating at the bottom centre above the player
// (--cl-player-h). ToastHost draws it.
//   toast("Liked")
//   toast("Couldn't join Friday jam.", { action: { label: "Try again", onClick } })
import { reactive } from "vue";

export const toastState = reactive({ show: false, text: "", action: null, seq: 0, timeout: 2600 });

export function toast(text, { action = null, timeout = null } = {}) {
  toastState.text = String(text || "");
  toastState.action = action && action.label ? action : null;
  toastState.timeout = timeout || (toastState.action ? 5000 : 2600);
  toastState.seq += 1;
  toastState.show = true;
}

export function dismissToast() {
  toastState.show = false;
}

export default toast;
